<template>
  <v-menu
    top
    :value="computedIsVisible"
    :attach="`#${attachId}`"
    transition="scroll-y-transition"
    :close-on-content-click="false"
    :close-on-click="false"
    :open-on-click="false"
    min-width="280"
    z-index="1"
  >
    <v-card scrollable>
      <v-list>
        <v-list-item ripple @mousedown.prevent @click="toggleSelectAll">
          <v-list-item-action class="mr-3">
            <v-icon :color="selectedFeatures.length > 0 ? 'primary' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-left">
              {{ $i18n.t('button.selectAllItems') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-text class="pa-0" style="max-height: 160px; overflow-y: auto">
        <v-list>
          <v-list-item-group v-model="selectedFeatures" multiple>
            <v-list-item
              v-for="feature in features"
              :key="feature.feature_id"
              :value="feature"
              @mouseleave="onHover({ layerId: feature.layer_id, id: feature.feature_id }, false)"
              @mouseenter="onHover({ layerId: feature.layer_id, id: feature.feature_id }, true)"
            >
              <template v-slot:default="{ active }">
                <v-list-item-action class="mr-3">
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-tooltip bottom color="font" max-width="300" :disabled="featureText(feature).length <= 23">
                    <template #activator="{ on }">
                      <v-list-item-title class="text-left" v-on="on">{{ featureText(feature) }}</v-list-item-title>
                    </template>
                    <div style="word-break: break-all;">
                      {{ featureText(feature) }}
                    </div>
                  </v-tooltip>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="computedIsVisible = false">
          {{ $i18n.t('button.cancel') }}
        </v-btn>
        <v-btn text color="primary" @click="handleAssign" :disabled="selectedFeatures.length === 0">
          {{ $i18n.t('button.assign') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { get } from 'vuex-pathify';
import identificationSidebarCard from '@/mixins/identificationSidebarCard';

export default {
  name: 'MultipleRelationsMenu',
  mixins: [identificationSidebarCard],
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    attachId: {
      type: String,
      required: true,
    },
    features: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedFeatures: [],
  }),
  computed: {
    layersMetadata: get('layers/metadata'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    allFeaturesSelected() {
      return this.selectedFeatures.length === this.features.length;
    },
    someFeaturesSelected() {
      return this.selectedFeatures.length > 0 && !this.allFeaturesSelected;
    },
    icon() {
      if (this.allFeaturesSelected) return 'mdi-checkbox-marked';
      if (this.someFeaturesSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  methods: {
    featureText(feature) {
      return `${this.layersMetadata[feature.data_source_name].verbose_name}: ${feature.feature_id}`;
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.allFeaturesSelected) {
          this.selectedFeatures = [];
        } else {
          this.selectedFeatures = this.features.slice();
        }
      });
    },
    handleAssign() {
      this.$emit('assignRelations', this.selectedFeatures);
      this.computedIsVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  top: initial !important;
  bottom: -5px !important;
  left: -5px !important;
}
</style>
